import { configureStore, combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage' // localStorage
import {
	persistReducer,
	persistStore,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from 'redux-persist'

import authSlice from './slices/authSlice'
import themeSlice from './slices/themeSlice'
import pusherSlice from './slices/pusherSlice'
import settingsSlice from './slices/settingsSlice'
import navbarSlice from './slices/navbarSlice'
import navigationSlice from './slices/navigationSlice'
import ticketsSlice from './slices/ticketsSlice'
import currentMixDataSlice from './slices/currentMixDataSlice'
import donationSlice from './slices/donationSlice'
import paymentCompleteSlice from './slices/paymentCompleteSlice'
import accountSlice from './slices/accountSlice'
import tagsSlice from './slices/tagsSlice'

const persistConfig = {
	key: 'app',
	storage,
	whitelist: ['navigation', 'tickets', 'donation', 'account'],
}

const rootReducer = combineReducers({
	currentMixData: currentMixDataSlice,
	settings: settingsSlice,
	theme: themeSlice,
	auth: authSlice,
	pusher: pusherSlice,
	navigation: navigationSlice,
	tickets: ticketsSlice,
	navbar: navbarSlice,
	donation: donationSlice,
	account: accountSlice,
	paymentCompleteDetails: paymentCompleteSlice,
	tags: tagsSlice,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
})

export const persistor = persistStore(store)

export default store
